import { validateLocale } from '@/services/localeValidation.js';

export default {
  install(app) {
    function updateLocale(newLocale) {
      validateLocale(newLocale);
      app.config.globalProperties.$rttI18n.setLocale(newLocale);
      app.config.globalProperties.$rttMoment.setLocale(newLocale);
    }

    function updateTenantId(newTenantId) {
      app.config.globalProperties.$rttI18n.setTenantId(newTenantId);
      app.config.globalProperties.$rttMoment.setTenantId(newTenantId);
    }

    app.config.globalProperties.$localePlugin = {
      updateLocale,
      updateTenantId
    };
    app.provide('localePlugin', { updateLocale, updateTenantId });
  }
};
